import React from 'react';

import BaseGraph from './BaseGraph';
import ByZonesGraphLabel from './ByZonesGraphLabel';
import { getMessage } from 'util/locale';
import { LINE_TYPES } from 'constants/advanced';

const ByZonesGraph = () => {
  return (
    <section className='graph-container'>
      <header>
        <p>{getMessage('new-plan-by-zones')}</p>
      </header>
      <BaseGraph linesToShow={LINE_TYPES.BY_ZONES_YIELD} />
      <ByZonesGraphLabel />
    </section>
  );
};

export default ByZonesGraph;
